import { Select, SelectProps } from 'antd';

export type SelectAtomProps = SelectProps;

const SelectAtom = Select;

export default SelectAtom;